import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import buttonStyles from "../../../styles/button.module.css";
import { updateIconColor, getIconButtonSize } from "../../../utils/buttonUtil";
import { buttonSizeType } from "../../../types/common";

export default function IconLinkButton({
  icon,
  classes,
  disable,
  to,
  iconColor,
  buttonBgColor,
  size
}: {
  classes?: string;
  disable?: boolean;
  icon: React.ReactNode;
  to: string;
  iconColor?: string;
  buttonBgColor?: string;
  size?: buttonSizeType;
}) {
  const iconLinkButton = useRef(null);

  useEffect(() => {
    if (iconLinkButton.current)
      updateIconColor(iconLinkButton.current, iconColor);
  }, [iconLinkButton, iconColor]);

  return disable ? (
    <div
      ref={iconLinkButton}
      className={`
        ${buttonStyles.iconButton} ${getIconButtonSize(size)}
        ${disable ? buttonStyles.iconLinkDisable : ""} ${classes || ""}
      `}
      style={{
        backgroundColor: buttonBgColor ? buttonBgColor : ""
      }}
    >
      {icon}
    </div>
  ) : (
    <Link
      ref={iconLinkButton}
      to={to}
      className={`${buttonStyles.iconButton} ${getIconButtonSize(size)} ${
        classes || ""
      }`}
      style={{
        backgroundColor: buttonBgColor ? buttonBgColor : ""
      }}
    >
      {icon}
    </Link>
  );
}
